import { Grid } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import SubsidyInfographic from './SubsidyInfographic';
import ErrorBoundary from '../ErrorBoundary';
// import Filters from './Filters';

function Q1Row1() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const { lightColor } = useContext(StoryContext);

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <SubquestionBox color={lightColor}>
        <Grid container spacing={2}>
          {/* <Grid item xs={12}>
            <Filters />
          </Grid> */}
          <Grid item xs={12}>
            <ErrorBoundary>
              <SubsidyInfographic />
            </ErrorBoundary>
          </Grid>
        </Grid>
      </SubquestionBox>
    </FiltersContext.Provider>
  );
}

export default Q1Row1;
